<template>
  <div>
    <EmptyModal :modalData="modalData" :onModalClose="closeModal">
      <slot>
        <div class="text-left">
          <div class="text-center m-b-5">
            <VuePhoneNumberInput
              v-model="dialNumber"
              :translations="translations"
              default-country-code="RU"
              :preferred-countries="['RU', 'BY', 'UA']"
              @update="updateClientPhone"
            />
          </div>
          <div v-if="false" class="flex">
            <template
              v-if="
                !$userPhoneNumbers ||
                  !$userPhoneNumbers.availablePhones ||
                  !Object.keys($userPhoneNumbers.availablePhones).length
              "
            >
              <h4>У Вас нет активных номеров, обратитесь к администратору</h4>
            </template>
            <template v-else>
              <div
                v-for="(project, index) in $userPhoneNumbers.availablePhones"
                :key="index"
                class="phone_block"
              >
                <h5>{{ $AllProjects[index].name }}</h5>
                <h5>
                  {{
                    userPhones[index] &&
                    userPhones[index][0] &&
                    $userPhoneNumbers.availableSip[
                      userPhones[index][0].mango_acc_id
                      ].sip_login
                  }}
                </h5>
                <draggable
                  v-model="userPhones[index]"
                  tag="div"
                  @update="updateOrder"
                >
                  <transition-group type="transition" name="flip-list">
                    <div
                      v-for="phone in userPhones[index]"
                      :key="phone.id"
                      class="phone_group"
                    >
                      <i class="icon-fa icon-fa-arrows pointer"></i>
                      <vue-ladda
                        @click="makePhoneCall(phone)"
                        button-class="btn btn-success btn-xs phoneCall_btn"
                        data-style="zoom-in"
                        :loading="phone.loading"
                      ><i class="icon-fa icon-fa-phone-square"></i>
                      </vue-ladda>
                      {{ phone.line_number }} ({{ phone.phone_title }})
                    </div>
                  </transition-group>
                </draggable>
              </div>
            </template>
            <div class="p-l-10">
              <h5>История звонков</h5>
              <div class="phone_history_block">
                <div v-if="downloadingHistory">
                  <pulse-loader
                    :loading="downloadingHistory"
                    :color="loadingColor"
                    class="text-center"
                  />
                </div>
                <div v-else>
                  <template v-if="!historyRecords.length">
                    <p>Звонков не найдено!</p>
                  </template>
                  <template>
                    <div
                      v-for="record in historyRecords"
                      :key="record.id"
                      class="history_phone_record"
                    >
                      <p>
                        {{
                          record.phoneData
                            ? $AllProjects[record.phoneData.project_id].name +
                            " (" +
                            $AllCities[record.phoneData.city_id].short_name +
                            ")"
                            : "Не определено направление"
                        }}
                      </p>
                      <p>
                        <i
                          v-bind:class="{
                            'icon-fa': true,
                            'icon-fa-arrow-circle-left green':
                              record.type_id === 1,
                            'icon-fa-arrow-circle-right blue':
                              record.type_id === 2
                          }"
                        ></i>
                        {{ record.phone_title || "не определен" }} =>
                        {{ record.destination }}
                      </p>
                      <div v-if="record.showRecord">
                        <audio controls v-if="record.audio_record_id">
                          <source
                            :src="
                              `https://admin.rancond.info/api/noa/mangoRecord/${record.id}`
                            "
                            type="audio/mpeg"
                          />
                          Your browser does not support the audio tag.
                        </audio>
                      </div>
                      <div class="flex justify-content-between">
                        <span>
                          <template v-if="record.order_id">
                            <button
                              @click="loadOrder(record.order_id)"
                              class="btn btn-info btn-xs"
                              type="button"
                            >
                              {{ record.order_id }}
                            </button>
                          </template>
                          <template
                            v-if="!record.showRecord && record.file_link"
                          >
                            <button
                              @click="record.showRecord = true"
                              class="btn btn-success btn-xs"
                              type="button"
                            >
                              Показать запись звонка
                            </button>
                          </template>
                        </span>
                        <span class="text-muted">{{ record.created_at }}</span>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-wrap">
            <template v-if="!$userPhoneNumbers || !$userPhoneNumbers.availableSip">
              <h4>У Вас нет активных номеров, обратитесь к администратору</h4>
            </template>
            <template v-else>
              <div v-for="(sip, index) in $userPhoneNumbers.availableSip" class="phone_block">
                <!--                <p v-if="phonesOrder[sip.acc_id] && phonesOrder[sip.acc_id][0] && $AllProjects[phonesOrder[sip.acc_id][0].connected_phone.site_id].name"></p>-->
                <p v-if="phonesOrder[sip.acc_id] && phonesOrder[sip.acc_id][0]">
                  {{
                    $AllProjects[phonesOrder[sip.acc_id][0].connected_phone.site_id] && $AllProjects[phonesOrder[sip.acc_id][0].connected_phone.site_id].name || 'не указано имя'
                  }}</p>
                <p>{{ sip.sip_login }}</p>
                <div>
                  <draggable
                    v-model="phonesOrder[sip.acc_id]"
                    tag="div"
                    @update="updateOrderList(sip.acc_id)"
                  >
                    <transition-group type="transition" name="flip-list">
                      <div
                        v-for="phone in phonesOrder[sip.acc_id]"
                        :key="phone.id"
                        class="phone_group"
                      >
                        <i class="icon-fa icon-fa-arrows pointer"></i>
                        <vue-ladda
                          @click="makePhoneCall2(phone.connected_phone, sip)"
                          button-class="btn btn-success btn-xs phoneCall_btn"
                          data-style="zoom-in"
                          :loading="phone.loading"
                        ><i class="icon-fa icon-fa-phone-square"></i>
                        </vue-ladda>
                        {{ phone.connected_phone.display_phone }} ({{ phone.connected_phone.description }})
                      </div>
                    </transition-group>
                  </draggable>
                </div>
              </div>
            </template>
            <div class="p-l-10">
              <h5>История звонков</h5>
              <div class="phone_history_block">
                <div v-if="downloadingHistory">
                  <pulse-loader
                    :loading="downloadingHistory"
                    :color="loadingColor"
                    class="text-center"
                  />
                </div>
                <div v-else>
                  <template v-if="!historyRecords.length">
                    <p>Звонков не найдено!</p>
                  </template>
                  <template>
                    <div
                      v-for="record in historyRecords"
                      :key="record.id"
                      class="history_phone_record"
                    >
                      <p>
                        {{
                          record.phoneData
                            ? $AllProjects[record.phoneData.project_id].name +
                            " (" +
                            $AllCities[record.phoneData.city_id].short_name +
                            ")"
                            : "Не определено направление"
                        }}
                      </p>
                      <p>
                        <i
                          v-bind:class="{
                            'icon-fa': true,
                            'icon-fa-arrow-circle-left green':
                              record.type_id === 1,
                            'icon-fa-arrow-circle-right blue':
                              record.type_id === 2
                          }"
                        ></i>
                        {{ record.phone_title || "не определен" }} =>
                        {{ record.destination }}
                      </p>
                      <div v-if="record.showRecord">
                        <audio controls v-if="record.audio_record_id">
                          <source
                            :src="
                              `https://admin.rancond.info/api/noa/mangoRecord/${record.id}`
                            "
                            type="audio/mpeg"
                          />
                          Your browser does not support the audio tag.
                        </audio>
                      </div>
                      <div class="flex justify-content-between">
                        <span>
                          <template v-if="record.order_id">
                            <button
                              @click="loadOrder(record.order_id)"
                              class="btn btn-info btn-xs"
                              type="button"
                            >
                              {{ record.order_id }}
                            </button>
                          </template>
                          <template
                            v-if="!record.showRecord && record.file_link"
                          >
                            <button
                              @click="record.showRecord = true"
                              class="btn btn-success btn-xs"
                              type="button"
                            >
                              Показать запись звонка
                            </button>
                          </template>
                        </span>
                        <span class="text-muted">{{ record.created_at }}</span>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </slot>
    </EmptyModal>
  </div>
</template>

<script>
import api from "@/api";
import EmptyModal from "@/components/modals/EmptyModal.vue";
import VueLadda from "vue-ladda/src/vue-ladda.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import draggable from "vuedraggable";
// import store from '@/store/index';

export default {
  components: {
    EmptyModal,
    VueLadda,
    VuePhoneNumberInput,
    draggable
  },
  props: ["closeModal"],
  data() {
    return {
      updatingSort: false,
      userPhones: {},
      phonesOrder: {},
      projectsPhones: {},
      loadingColor: this.$constants.LOADING_COLOR,
      downloadingHistory: false,
      historyRecords: [],
      phoneCallLoading: {},
      asyncRequest: false,
      dialNumber: null,
      dialNumberFormatted: null,
      availablePhones: {},
      modalData: {
        header: "Инициировать вызов",
        disableFooter: true
      },
      translations: {
        countrySelectorLabel: "Код страны",
        countrySelectorError: "Телефон не верный",
        phoneNumberLabel: "Номер телефона",
        example: "Пример :"
      }
    };
  },
  computed: {
    $AllCities() {
      return this.$store.getters["platform/cities"];
    },
    $userPhoneNumbers() {
      const phonesData = this.$store.getters["user/phoneNumbers"];
      // const availablePhones = phonesData.numbers.reduce((acc, p) => {
      //   if (!acc[p.project_id]) acc[p.project_id] = [];
      //   acc[p.project_id].push({...p, loading: false});
      //   return acc;
      // }, {});
      // console.log(phonesData);
      const sipPhones = phonesData.phoneNumbers.reduce((acc, p) => {
        if (!p.connected_phone?.service_id) return acc;
        if (!acc[p.connected_phone.service_id]) acc[p.connected_phone.service_id] = [];
        acc[p.connected_phone.service_id].push({...p, loading: false});
        return acc;
      }, {});
      const availableSip = phonesData.sipAccounts.reduce((acc, s) => {
        acc[s.acc_id] = {...s};
        return acc;
      }, {});
      return {availableSip, sipPhones};
    },
    $AllProjects() {
      const projects = this.$store.getters["platform/projects"].reduce(
        (acc, p) => {
          acc[p.id] = {...p};
          return acc;
        },
        {}
      );
      return projects;
    }
  },
  mounted() {
    this.userPhones = {...this.$userPhoneNumbers.availablePhones};
    this.projectsPhones = Object.keys(this.userPhones).reduce(
      (acc, projectId) => {
        this.userPhones[projectId].forEach(p => {
          if (!acc[p.mango_acc_id]) acc[p.mango_acc_id] = {};
          acc[p.mango_acc_id][p.line_number] = {
            city_id: p.city_id,
            project_id: p.project_id
          };
        });
        return acc;
      },
      {}
    );
    this.getCallHistory();
    this.phonesOrder = {...this.$userPhoneNumbers.sipPhones};
  },
  methods: {
    async updateOrderList(accId) {
      this.updatingSort = true;
      console.log('update', accId);
      let {data} = await api.post("/telephony/updateUserPhoneOrder", {
        phoneGroup: this.phonesOrder[accId].map((r) => r.id)
      });
      this.updatingSort = false;
    },
    async updateOrder(e = null) {
      this.updatingSort = true;
      let {data} = await api.post("/telephony/updateUserLines", {
        phoneGroup: this.userPhones
      });
      if (data.success) {
        this.$store.dispatch("user/setPhoneNumbers", data.records);
      }
      this.updatingSort = false;
    },
    loadOrder(id) {
      this.mixinGoToRouter("editOrder", {id: id});
      this.closeModal();
    },
    async getCallHistory() {
      this.downloadingHistory = true;
      let {data} = await api.index(
        "/telephony/getCallHistory?userId=" + this.$currentUID
      );
      if (data.success) {
        if (data.updatePhones) {
          store.dispatch("user/setPhoneNumbers", {
            numbers: data.phoneNumbers,
            sipAccounts: data.sipAccounts
          });
        }
        this.historyRecords = data.records.reduce((acc, r) => {
          acc.push({
            ...r,
            showRecord: false,
            phoneData:
              (this.projectsPhones[r.mango_acc_id] &&
                this.projectsPhones[r.mango_acc_id][
                  r.type_id === 1 ? r.destination : r.phone_title
                  ]) ||
              null
          });
          return acc;
        }, []);
      }
      this.downloadingHistory = false;
    },
    updateClientPhone(e) {
      if (e.isValid) {
        this.dialNumberFormatted = e.e164;
      }
    },
    async makePhoneCall(phone) {
      console.log(phone);
      if (!this.dialNumber) {
        toastr["warning"]("Номер не указан");
        return;
      }
      if (this.asyncRequest) {
        return;
      }
      phone.loading = true;
      this.asyncRequest = true;
      let {data} = await api.post("/telephony/makePhoneCall", {
        mango_phone_id: phone.id,
        phone: {phone: this.dialNumberFormatted}
      });
      if (data.success) {
        toastr["success"](data.message || data.sip || '', "Вызов создан");
        this.closeModal();
      } else {
        toastr["warning"](
          data.message || "Вызов не создан, обратитесь к адмнистратору"
        );
      }
      phone.loading = false;
      this.asyncRequest = false;
    },
    async makePhoneCall2(phone, sip) {
      if (!this.dialNumber) {
        toastr["warning"]("Номер не указан");
        return;
      }
      if (this.asyncRequest) {
        return;
      }
      phone.loading = true;
      this.asyncRequest = true;
      let {data} = await api.post("/telephony/makePhoneCall2", {
        sip: sip.id,
        mango_phone_id: phone.id,
        phone: this.dialNumberFormatted
      });
      if (data.success) {
        toastr["success"](data.message || data.sip || '', "Вызов создан");
        this.closeModal();
      } else {
        toastr["warning"](
          data.message || "Вызов не создан, обратитесь к адмнистратору"
        );
      }
      phone.loading = false;
      this.asyncRequest = false;
    }
  }
};
</script>

<style scoped>
.history_phone_record {
  border: 1px solid lightgray;
  padding: 3px 5px;
  margin-bottom: 3px;
}

audio {
  height: 25px;
}

.phone_history_block {
  max-height: 60vh;
  overflow: hidden;
  overflow-y: auto;
}

.icon-fa.green {
  color: #4fc47f;
}

.icon-fa.blue {
  color: #02a2f8;
}

.text-muted {
  font-size: 12px;
}

.ladda-label {
  position: static;
}

.phoneCall_btn {
  margin: 3px !important;
}

.phoneCall_btn i {
  text-align: center;
}

.phone_group {
  padding-left: 5px;
  border: 1px solid lightgray;
  margin-bottom: 2px;
  background-color: #f9f9f9;
}

.phone_group .fa {
  cursor: pointer;
}

.phone_block {
  padding-right: 10px;
}
</style>
